import _ from 'underscore';
import { InvalidateStrategy } from './base';

import { BUILTIN_WRITE_ACTIONS } from '../constants';

export class WriteActionInvalidateStrategy extends InvalidateStrategy {
  /**
   * Invaliadate the cache of certain resource on write
   * @param {Object} options -
   * @param {string[]} options.writeActions - The additional write actions
   */
  constructor({
    writeActions = [],
  } = {}) {
    super();
    this.writeActions = _.union(writeActions, BUILTIN_WRITE_ACTIONS);
  }

  /**
   * Handler for the afterExecute notification. Invalidate the cache for the
   * given resource if its a succeeded write action.
   * @abstract
   * @param {JSDataCacheManager} cacheManager - The subject of the notification
   * @param {AfterExecuteParameters} params - The notification parameters
   * @returns {void}
   */
  afterExecute(cacheManager, {
    action,
    isSuccess,
    parameters: [{
      name: resource,
    }],
  }) {
    if (isSuccess && _.contains(this.writeActions, action)) {
      cacheManager.invalidate(resource);
    }
  }
}
